// @flow

/**
 * Check if two arrays are identical
 *
 * @param a
 * @param b
 * @returns boolean
 */
export const areEqual = (a: Array<any>, b: Array<any>): boolean => {
  if (a.length !== b.length) return false;

  for (let i: number = 0; i < a.length; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }

  return true;
};

export const arraysAreEqual = (a: Array<any>, b: Array<any>): boolean => {
  if (!Array.isArray(a)) return false;
  if (!Array.isArray(b)) return false;
  return areEqual(a, b);
};
